import { IPerformanceOptions } from '../hooks/apis/use-reports-list';
import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import { PerformanceResponse } from '../models/performance.model';
import { getConfig } from '@monorepo/tools/src/lib/get-config';
import { getManagementApiBaseUrl } from '../utils/management-api';

const getUrl = () => {
	const { localReportApi } = getConfig().env;

	return localReportApi ? `${localReportApi}/report` : `${getManagementApiBaseUrl()}/reports/report`;
};

export const PerformanceApi = {
	performance(params: IPerformanceOptions): Promise<PerformanceResponse> {
		return ask.post<IPerformanceOptions>(getUrl(), params).then(res => res.payload);
	},
	downloadCsv(params?: IPerformanceOptions): Promise<File | null> {
		return ask.downloadPost<IPerformanceOptions>(`${getUrl()}/download`, params || {});
	},
	generateCsv(params?: IPerformanceOptions): Promise<File | null> {
		return ask.post<IPerformanceOptions>(`${getUrl()}/generate-csv`, params || {});
	},
};
